module.exports = __webpack_public_path__ + "static/media/hdir-logo-hvit.d1cd153a.svg";